/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SearchSortField, SearchSortOrder } from "~/generated/graphql";
import { SortDirection, SortSelector, Option } from "~/components";

const SELECT_OPTIONS = [
  {
    value: SearchSortField.Cost,
    label: "Monthly Costs",
  },
  {
    value: SearchSortField.Type,
    label: "Type/Subtype",
  },
  {
    value: SearchSortField.Region,
    label: "Region",
  },
  {
    value: SearchSortField.ProviderId,
    label: "Resource name",
  },
  {
    value: SearchSortField.SavingsAmount,
    label: "Savings amount",
  },
];

type Props = {
  sortField: string;
  sortDirection: SearchSortOrder;
  onSortSelect: (value: SearchSortField) => void;
  onSortOrderChange: (value: SortDirection) => void;
  options?: Option[];
};

export function EstateSort({
  sortField,
  sortDirection,
  onSortSelect,
  onSortOrderChange,
  options = SELECT_OPTIONS,
}: Props) {
  return (
    <SortSelector
      options={options}
      value={sortField}
      direction={
        sortDirection === SearchSortOrder.Asc
          ? SortDirection.Ascending
          : SortDirection.Descending
      }
      onSelect={(filter) => onSortSelect(filter as SearchSortField)}
      onSortChange={onSortOrderChange}
    />
  );
}
